import { getComposeViewState } from 'owa-mail-reading-pane-store-conversation/lib/utils/getComposeViewState';
import { type Suggestion, type Suggestions } from './suggestionCatalog';
import { getCachedSuggestedDrafts } from 'owa-copilot-suggested-drafts/lib/cache/suggestedDraftsCache';
import { executePromptWithQueryAnnotation } from './executePromptWithQueryAnnotation';
import loc from 'owa-localize';
import { replyPromptText, draftReply } from './getComposingSuggestions.locstring.json';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';

export function getComposingSuggestions(): Suggestions {
    const composeViewState = getComposeViewState();

    if (!isFeatureEnabled('mon-copilot-dab-experiment-draft-reply') || !composeViewState) {
        return undefined;
    }

    const { conversationId, referenceItemId } = composeViewState;

    const [cachedSuggestedDrafts] = getCachedSuggestedDrafts(
        referenceItemId?.Id ?? '',
        conversationId ?? '',
        'Polaris',
        () => {},
        'Outlook'
    );

    const suggestedDraft1Text = cachedSuggestedDrafts[0]?.text;
    const suggestedDraft2Text = cachedSuggestedDrafts[1]?.text;
    const suggestedDraft3Text = cachedSuggestedDrafts[1]?.text;

    const hasSuggestedDrafts =
        cachedSuggestedDrafts.length >= 3 &&
        suggestedDraft1Text &&
        suggestedDraft2Text &&
        suggestedDraft3Text;

    if (!hasSuggestedDrafts) {
        return undefined;
    }

    // For composing scenario, we prompts for suggested drafts if they were generated
    return [
        getDraftSuggestion('suggestedDraft1', suggestedDraft1Text),
        getDraftSuggestion('suggestedDraft2', suggestedDraft2Text),
        getDraftSuggestion('suggestedDraft3', suggestedDraft3Text),
    ];
}

const getDraftSuggestion = (id: string, text: string): Suggestion => {
    return {
        displayTextLocalized: loc(draftReply, text),
        id,
        onClick: () => executePromptWithQueryAnnotation(loc(replyPromptText, text), 'cmm9uaofbq8'),
    };
};
